/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const DEFAULT_LEAVE_CONFIRMATION_COPY = {
	title: 'Unsaved changes',
	message: 'Are you sure you want to leave the page? Your changes will not be saved.',
	confirmLabel: 'Leave without saving',
	cancelLabel: 'Keep editing'
};

export const slice = createSlice({
	name: 'navigate',
	initialState: {
		preventNavigation: false,
		showPrompt: false,
		leaveConfirmationCopy: DEFAULT_LEAVE_CONFIRMATION_COPY
	},
	reducers: {
		setPreventNavigation: (state, action) => {
			state.preventNavigation = action.payload;
		},
		setShowPrompt: (state, action) => {
			state.showPrompt = action.payload;
		},
		setLeaveConfirmationCopy: (state, action) => {
			state.leaveConfirmationCopy = action.payload || DEFAULT_LEAVE_CONFIRMATION_COPY;
		}
	}
});

export const setPreventNavigation = (preventNavigation) => async (dispatch) => {
	dispatch(slice.actions.setPreventNavigation(preventNavigation));
};

export const setShowPrompt = (showPrompt) => async (dispatch) => {
	dispatch(slice.actions.setShowPrompt(showPrompt));
};

export const setLeaveConfirmationCopy = (copy) => async (dispatch) => {
	dispatch(slice.actions.setLeaveConfirmationCopy(copy));
};

export const navigate = (state) => state.navigate;

export const preventNavigation = (state) => state.navigate.preventNavigation;
export const showPrompt = (state) => state.navigate.showPrompt;
export const leaveConfirmationCopy = (state) => state.navigate.leaveConfirmationCopy;

export default slice.reducer;
